<div class="email-form-container">
    <mat-card appearance="outlined">
      <mat-card-title>Send Email</mat-card-title>
      <mat-card-content>
        <form [formGroup]="emailForm" (ngSubmit)="onSubmit()">
          <mat-form-field appearance="outline" style="width: 400px; margin-left: 10px;">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" type="email" placeholder="Enter recipient's email" required/>
            <mat-error *ngIf="emailForm.get('email').hasError('required')">
              Email is required
            </mat-error>
            <mat-error *ngIf="emailForm.get('email').hasError('email')">
              Invalid email address
            </mat-error>
          </mat-form-field>
        <br>
          <mat-form-field appearance="outline" style="width: 400px; margin-left: 10px;">
            <mat-label>Email Template File</mat-label>
            <input matInput formControlName="emailTemplateFile" placeholder="Enter template file name" required />
          </mat-form-field>
          <br>
          <mat-form-field appearance="outline" style="width: 400px; margin-left: 10px;">
            <mat-label>Subject</mat-label>
            <input matInput formControlName="subject" placeholder="Enter email subject" required />
          </mat-form-field>
          <br>
          <button mat-raised-button color="primary" style="margin: 10px;" type="submit" [disabled]="emailForm.invalid">Send Email</button>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
  